import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  ICirculationEventsGetAllParams,
  ICirculationEventsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICirculationEventsResponse>>,
  IPathBaseParam,
  IPaginationParams & ICirculationEventsGetAllParams
>("stores.warehouses.circulationEvents");

const getApis = createGetApi<
  IApiResponse<ICirculationEventsResponse>,
  IPathByIdParam,
  object
>("stores.warehouses.circulationEvents");

export const circulationEvents = {
  ...getAllApis,
  ...getApis,
};
